@if (
  {
    offline: offline$ | async,
    gdprFunctional: gdprFunctional$ | async,
    isJcEmployee: isJcEmployee$ | async,
  };
  as vm
) {
  @if (vm.isJcEmployee) {
    <mkp-read-only-banner />
  }
  <router-outlet />
  <mkp-version />
  <ui-snackbar />
  @if (vm.offline) {
    <mkp-no-network />
  }
  <mkp-gdpr-consent />

  @if (!vm.gdprFunctional) {
    <ui-gdpr-zendesk-placeholder />
  }
  <ng-container #debugger />
}
